export const theme = {
    color: {
    // Brand
    // #051729
        primary: 'hsl(210, 78%, 9%)',
        // #c6152b
        secondary: '#450a0e',

        // Variations
        primaryDark: 'hsl(210, 78%, 6%)',
        primaryLight: 'hsl(210, 78%, 12%)',
        secondaryDark: '#3BB2BC',
        secondaryLight: '#3BB2BC',
        dangerLight: 'rgb(217 83 79 / 5%);',

        // Context
        success: '#5cb85c',
        info: '#c6152b',
        warning: '#c8a554',
        danger: '#d9534f',

        grayBackground: '#f6f6f6',
    },
    font: {
        default: '\'Titillium Web\', sans-serif',
        alt: '\'Roboto Condensed\', sans-serif',
    },
    fontWeight: {
        light: 200,
        book: 300,
        regular: 400,
        medium: 600,
        bold: 700,
        black: 900,
    },
    filter: {
        white: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(317deg) brightness(103%) contrast(102%)',
        primary: 'invert(6%) sepia(19%) saturate(5328%) hue-rotate(189deg) brightness(94%) contrast(97%)',
        secondary: 'invert(15%) sepia(95%) saturate(3520%) hue-rotate(343deg) brightness(84%) contrast(97%)',
        grayRegular: 'invert(55%) sepia(0%) saturate(0%) hue-rotate(87deg) brightness(91%) contrast(92%)',
        grayDark: 'invert(34%) sepia(0%) saturate(1%) hue-rotate(31deg) brightness(97%) contrast(89%)',
        success: 'invert(60%) sepia(61%) saturate(422%) hue-rotate(71deg) brightness(96%) contrast(80%)',
        danger: 'invert(41%) sepia(90%) saturate(590%) hue-rotate(317deg) brightness(89%) contrast(90%)',
        warning: 'invert(77%) sepia(84%) saturate(375%) hue-rotate(338deg) brightness(86%) contrast(80%)',
    },
    breakpoint: {
        small: '600px',
        medium: '800px',
        large: '1200px',
    },
    backgroundColor: '#f8f9fa',
}
